enum HotelRoomView {
  GROUPEDBYROOMCONFIG = 'GROUPEDBYROOMCONFIG',
  ROOMCONTAINSALLROOMCONFIG = 'ROOMCONTAINSALLROOMCONFIG'
}
export default HotelRoomView;
